<template>
    <div class="content-main" v-if="activityInfo">
        <div class="top-bar com-model m-b-15">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/index/jobfair' }">招聘会</el-breadcrumb-item>
                <el-breadcrumb-item>招聘会详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="com-model m-b-15" style="padding: 24px;">
          <activity-item :item="activityInfo" itemType="detail"/>
        </div>
        <div class="com-model m-b-15" style="padding: 0 24px">
          <div class="title m-b-20">招聘会简介</div>
          <div class="content">
            <div class="desc-img">
              <img :src="activityInfo.descImage" />
            </div>
            <div class="desc-text">
                {{activityInfo.description}}
            </div>
          </div>
        </div>
        <div class="com-model" style="padding: 0 24px 37px">
          <div class="title m-b-20">报名企业<span>（{{activityInfo.companyInfoList.length}}）</span></div>
          <div class="company-list flex">
            <template  v-for="(item, index) in activityInfo.companyInfoList" >
              <div class="company-item flex flex-between flex-column" :key="index" v-if="index < 4" >
                <div class="company-img">
                  <img :src="item.companyLogo" />
                </div>
                <div class="company-name">{{item.companyName}}</div>
              </div>
            </template>
            <div class="company-more flex flex-center" v-if=" activityInfo.companyInfoList.length > 4">
              <div class="dian" v-for="item in 3" :key="item"></div>
            </div>
          </div>
        </div>
        <!-- <div class="jobfair-box jobf-shadow" v-if="activityInfo.descImage" style="margin-top:18px;">
            <div class="jobf-tobar">
                <div class="jobf-tit">招聘会内容</div>
            </div>
            <div style="padding: 20px;">
                <img  style="width: 100%;height: auto;" :src="activityInfo.descImage">
            </div>
            <div>

            </div>
        </div>
        <div class="hadbm-box" v-if="activityInfo.isSign" style="background-color: #fff;margin-top: 20px;box-shadow: 0 0 7px #cbcbcb">
            <div class="hadbm-box-tit" id="bseatinfo">企业报名信息</div>
            <div class="hadbm-shen" v-if="activityInfo.isSignSuccess">
                <i class="iconfont icon-corrent_ico1"></i>
                <span>恭喜您已通过审核，请按时参加</span>
            </div>
            <div class="hadbm-shen" v-else style="color:#f4b01c;">
                <i class="iconfont icon-fault_ico"></i>
                <span>运营审核中，请耐心等待！</span>
            </div>
            <ul class="hadbm-list">
                <li>
                    <div class="hadbm-list-name">企业名称</div>
                    <div class="hadbm-list-namein">{{$store.state.hrinfo.companyName}}</div>
                </li>
                <li>
                    <div class="hadbm-list-name">联系人</div>
                    <div class="hadbm-list-namein">{{activityInfo.name}}</div>
                </li>
                <li>
                    <div class="hadbm-list-name">联系方式</div>
                    <div class="hadbm-list-namein">{{activityInfo.phone}}</div>
                </li>
                <li>
                    <div class="hadbm-list-name">举办地址</div>
                    <div class="hadbm-list-namein">{{activityInfo.address}}</div>
                </li>
                <li>
                    <div class="hadbm-list-name">选择摊位</div>
                    <div class="hadbm-list-namein">{{activityInfo.seatNo}}</div>
                </li>
            </ul>
        </div>
        <div class="jobfair-box jobf-shadow" v-else
             style="margin-top:18px;background-color: #fff;overflow: hidden;padding-bottom: 20px;">
            <div class="jobf-tobar">
                <div class="jobf-tit">企业报名表</div>
            </div>
            <div class="baoming-box">
                <div class="baoming-company">
                    <div class="baoming-company-tit">
                        <div class="baoming-company-name">企业名称</div>
                        <div class="baoming-company-people">联系人</div>
                         <div class="baoming-company-phone">联系方式</div>

                    </div>
                    <div class="baoming-company-info">
                        <div class="baoming-company-name">{{activityInfo.companyName}}</div>
                        <div class="baoming-company-people">{{activityInfo.name}}</div>

                        <div class="baoming-company-phone">{{activityInfo.phone}}</div>
                    </div>
                </div>
                 <div class="baoming-company" style="margin-top:25px;">
                    <div class="baoming-company-tit">
                        <div class="baoming-company-name">举办地址</div>
                    </div>
                    <div class="baoming-company-info">
                        <div class="baoming-company-name" style="width:518px;">{{activityInfo.address}}</div>
                    </div>
                </div>
                <div class="baoming-pic" style="padding-bottom:40px;">
                    <div class="baoming-pic-tit">
                        <img src="../../assets/images/ico.png">
                        <span>场地平面图</span>
                    </div>
                    <div style="margin: 20px 10px;">
                        <img class="preview-img"  v-for="(item, index) in list" :src="item.src"  style="max-width:100%;height:auto;cursor:pointer;" @click="$preview.open(index, list)">
                    </div>
                    <div class="tanwei" v-if="seatInfo.length > 0">
                        <div class="tanwei-tit">
                            <span>#选择摊位</span><span style="font-weight: bold;" v-if="seatno">·您已选择{{seatno}}摊位</span>
                        </div>
                        <ul class="tanwei-list">
                            <li v-for="(item,index) in seatInfo" :class="{'active':item.id == seatid}" @click="searSel(item.id,item.no)">{{item.no}}</li>
                        </ul>
                    </div>
                     <div class="tanwei" v-if="!seatInfo.length && tempseatInfo.length">
                        <div class="tanwei-tit tanwei-temptit">
                            <span class="tanwei-temptit-sd">#临时摊位</span><span style="font-weight: bold;" v-if="seatno">·您已选择{{seatno}}摊位</span>
                        </div>
                        <div class="tanwei-temptxt">以下座位为临时新增摊位，（若摊位图中无说明，实际摊位请服从主办方安排）。</div>
                        <ul class="tanwei-list tanwei-templist">
                            <li v-for="(item,index) in tempseatInfo" :class="{'active':item.id == seatid}" @click="searSel(item.id,item.no)">{{item.no}}</li>
                        </ul>
                    </div>
                    <div v-if="activityInfo.status != 2" id="bseat">
                      <div class="baoming-btn" v-if="seatInfo.length > 0 || tempseatInfo.length > 0" @click="subJobfair">提交报名信息</div>

                      <div class=""  v-if="seatInfo.length == 0 && tempseatInfo.length == 0">
                        <div class="baoming-btn baoming-gray-btn">名额已满</div>
                        <div style="font-size:16px;color:#666;font-weight:bold;letter-spacing:1px;margin-top:24px;"><i class="iconfont icon-fault_ico" style="color:#f4b01c;"></i> 温馨提示：主会场预报名已满！</div>
                        <ul class="baoming-manlist">
                           <li>·您可选择报名分会场招聘会</li>
                           <li>·联系0577-28888070林旭、0577-28888283少煌，通过线下预报名主会场招聘。</li>
                        </ul>
                      </div>
                    </div>

                </div>
                <div>

                </div>
            </div>
        </div>
        <div v-if="isbmsuc">
            <div class="ztx-modal"></div>
            <div class="ztx-message-box">
                <div class="ztx-message-main" style="width: 390px;">
                    <div class="ztx-message-tit" style="height: 54px;line-height: 54px;"><span>报名成功</span> <div @click="bmsucClose" class="ztx-message-close" style="color: #e5e5e5;font-weight: bold;">×</div></div>
                    <div class="bmsuc-box">
                        <div class="bmsuc-ic">
                            <i class="iconfont icon-corrent_ico1"></i>
                            <span>已报名成功，请等待运营审核</span>
                        </div>
                        <ul class="bmsuc-list">
                            <li>
                                <p class="bmsuc-list-l">企业名称</p>
                                <p class="bmsuc-list-r">{{activityInfo.companyName}}</p>
                            </li>
                            <li>
                                <p class="bmsuc-list-l">摊位编号</p>
                                <p class="bmsuc-list-r">{{seatno}}号</p>
                            </li>
                        </ul>
                        <div class="bmsuc-btn" @click="bmsucClose">好的，我知道了！</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="" v-if="imgBig">
            <div class="ztx-modal"></div>
            <div class="ztx-message-box">
                <div class="ztx-message-main" style="width: 810px;height: 620px;">
                    <img :src="scalesrc" style="width: 810px;height: 620px;">
                </div>
            </div>
            <div @click="imgBigClose" class="imgscale-clode"><img src="../../assets/images/x.png"></div>
        </div> -->

    </div>
</template>
<script>
import ActivityItem from '../../components/ActivityItem.vue';
export default {
  data() {
    return {
      a: 1,
      activityInfo: null,
      seatInfo: [],
      jbid: "",
      seatid: "",
      seatno: "",
      tempseatInfo: [],
      isbmsuc: false,
      imgBig: false,
      scalesrc: "",
      list: []
    };
  },
  created() {
    this.jbid = this.$route.query.jbid;
    this.getInfo();
    //this.getSeatInfo();
    //this.getTempSeatInfo();
  },
  components: { ActivityItem },
  methods: {
    imgScale(scalesrc) {
      this.imgBig = true;
      this.scalesrc = scalesrc;
    },
    imgBigClose() {
      this.imgBig = false;
    },
    bmsucClose() {
      this.getInfo();
      this.isbmsuc = false;
    },
    searSel(id, no) {
      this.seatid = id;
      this.seatno = no;
    },
    getInfo() {
      this.axios.get("/wapi/activity/get?activityId=" + this.jbid).then(res => {
        if (res.success) {
          this.activityInfo = res.data;
          var img = new Image();
          img.src = res.data.seatImage + "?t=" + Math.random();
          let w, h;
          let self = this;
          img.onload = function() {
            w = img.width;
            h = img.height;
            self.list.push({
              src: res.data.seatImage,
              w,
              h
            });
          };
        }
      });
    },
    getTempSeatInfo() {
      this.axios
        .get("/wapi/activity/listUnselectTempSeat?activityId=" + this.jbid)
        .then(res => {
          if (res) {
            this.tempseatInfo = res;
            /*this.seatInfo = res.filter(item => {
              return item.no < 122 || item.no > 220;
            })*/
          }
        })
        .catch(res => {});
    },
    getSeatInfo() {
      this.axios
        .get("/wapi/activity/listUnselectSeat?activityId=" + this.jbid)
        .then(res => {
          if (res) {
            this.seatInfo = res;
            /*this.seatInfo = res.filter(item => {
              return item.no < 122 || item.no > 220;
            })*/
          }
        })
        .catch(res => {});
    },
    subJobfair() {
      this.axios
        .get(
          `/wapi/activity/sign?activityId=${this.jbid}&seatId=${this.seatid}`
        )
        .then(res => {
          if (res.success) {
            this.isbmsuc = true;
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
.top-bar {
  padding: 22px 24px;
  line-height: 30px;
}
.com-model {
  border-radius: 10px;
}
.title{
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 74px;
  border-bottom: 1px solid #D2D2D2;
  span{
    color: rgba(153, 153, 153, 1);
  }
}
.content{
  padding: 0 60px 40px;
}
.desc-img{
  width: 100%;
  // height: 220px;
  text-align: center;
  img{
    max-width: 100%;
    max-height: 100%;
  }
}
.desc-text{
  font-size: 16px;
  color: rgba(85, 85, 85, 1);
  line-height: 28px;
}


.company-item, .company-more{
  width: 18%;
  margin-right: 2%;
  height: 100px;
  padding: 10px 0;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #E6E6E6;
  &.company-more{
    border: 0;
    .dian{
      width: 10px;
      height: 10px;
      background: #D8D8D8;
      border-radius: 50%;
      margin: 0 4px;
    }
  }
  .company-img{
    width: 50px;
    height: 50px;
    margin: 0 auto;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .company-name{
    font-weight: 500;
    color: #494949;
    line-height: 22px;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 40px;
    box-sizing: border-box;
    width: 100%;
    text-align: center;
  }
}
.baoming-manlist {
  margin-top: 20px;
  margin-left: 25px;
}
.baoming-manlist li {
  font-size: 14px;
  color: #666;
  margin-top: 15px;
  letter-spacing: 1px;
}
.tanwei-temptxt {
  font-size: 14px;
  color: #999;
  margin: 8px 0 6px 0;
}
.imgscale-clode {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -312px;
  margin-left: 415px;
  z-index: 10002;
  cursor: pointer;
}
.bmsuc-box {
  width: 330px;
  margin: 0 auto;
  .bmsuc-ic {
    color: #3abd37;
    font-size: 14px;
    margin: 25px 0 10px 0;
  }
  .bmsuc-list {
    li {
      overflow: hidden;
      height: 48px;
      line-height: 54px;
      font-size: 16px;
      border-bottom: 1px dashed #e5e5e5;
    }
    .bmsuc-list-l {
      color: #333;
      font-weight: bold;
      float: left;
    }
    .bmsuc-list-r {
      color: #666;
      float: right;
    }
  }
  .bmsuc-btn {
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    color: #fff;
    background-color: #495fcd;
    border-radius: 5px;
    margin: 30px 0;
    cursor: pointer;
  }
}
.ztx-message-tit {
  background-color: #fff;
  color: #333;
  border-bottom: 1px solid #e5e5e5;
}
.ztx-modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
  z-index: 101;
}
.hadbm-box {
  padding: 20px 0 100px 0;
}
.hadbm-box-tit {
  width: 100%;
  height: 70px;
  text-align: center;
  line-height: 70px;
  font-size: 20px;
  color: #333;
  background: url("../../assets/images/baomingtit.png") no-repeat center center;
}
.hadbm-shen {
  color: #3abd37;
  text-align: center;
  font-size: 16px;
  width: 520px;
  margin: 0 auto;
  padding-bottom: 5px;
  border-bottom: 1px solid #ccc;
}
.hadbm-shen .iconfont {
  font-size: 20px;
}
.hadbm-list {
  width: 520px;
  overflow: hidden;
  margin: 0 auto;
}
.hadbm-list li {
  overflow: hidden;
  height: 48px;
  line-height: 52px;
  border-bottom: 1px dashed #e5e5e5;
  font-size: 16px;
}
.hadbm-list-name {
  float: left;
  color: #333;
  font-weight: bold;
}
.hadbm-list-namein {
  float: right;
  color: #666;
}
.baoming-box {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 30px;
}

.baoming-company-tit {
  overflow: hidden;
}

.baoming-company-tit div {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  line-height: 1.1;
}

.baoming-company-info {
  overflow: hidden;
}

.baoming-company-info div {
  border-bottom: 1px solid #e5e5e5;
  font-size: 16px;
  color: #666;
  padding: 18px 0 10px;
}

.baoming-company .baoming-company-name {
  width: 290px;
  margin-right: 50px;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.baoming-company .baoming-company-people {
  width: 180px;
  margin-right: 50px;
  float: left;
}

.baoming-company .baoming-company-phone {
  width: 180px;
  float: left;
}

.baoming-pic-tit {
  margin-top: 30px;
}

.baoming-pic-tit img {
  width: 17px;
  height: 17px;
  vertical-align: bottom;
}

.baoming-pic-tit span {
  font-size: 16px;
  color: #333;
  margin-top: 2px;
}

.tanwei-list {
  overflow: hidden;
}

.tanwei-list li {
  float: left;
  width: 38px;
  height: 24px;
  margin-right: 10px;
  text-align: center;
  line-height: 24px;
  border-radius: 4px;
  border: 1px solid #495fcd;
  color: #495fcd;
  cursor: pointer;
  margin-top: 10px;
}
.tanwei-templist li {
  width: 65px;
  height: 30px;
  line-height: 30px;
  color: #ff6511;
  border-radius: 6px;
  border: 1px solid #ff6511;
}

.tanwei-list li.active {
  color: #fff;
  background-color: #495fcd;
}
.tanwei-templist li.active {
  background-color: #ff6511;
}
.tanwei-list li.disable {
  background-color: #ddd;
  color: #999;
  cursor: not-allowed;
  border-color: #ddd;
}

.tanwei-tit {
  font-size: 14px;
  color: #495fcd;
}
.tanwei-temptit {
  color: #ff6511;
}
.tanwei-temptit-sd {
  color: #333;
}

.baoming-btn {
  width: 220px;
  height: 46px;
  text-align: center;
  line-height: 46px;
  color: #fff;
  background-color: #495fcd;
  border-radius: 23px;
  margin-top: 30px;
  margin-bottom: 10px;
  cursor: pointer;
}
.baoming-gray-btn {
  background: #ccc;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// jobfairinfo.vue?b9ba05b4